export default "__VITE_ASSET__BajoHVTU__"